import axiosWithAuth from '../../utils/axiosWithAuth';
import { CreateExpenseData, UpdateExpenseData, ExpenseQueryParams } from '../../types/expense';

const API_BASE_URL = '/expenses';

export const expenseAPI = {
  createExpense: async (data: CreateExpenseData) => {
    const response = await axiosWithAuth.post(API_BASE_URL, data);
    return response.data;
  },

  getExpenses: async (params: ExpenseQueryParams = {}) => {
    const response = await axiosWithAuth.get(API_BASE_URL, { params });
    return response.data;
  },

  getExpense: async (uuid: string) => {
    const response = await axiosWithAuth.get(`${API_BASE_URL}/${uuid}`);
    return response.data;
  },

  updateExpense: async (uuid: string, data: UpdateExpenseData) => {
    const response = await axiosWithAuth.put(`${API_BASE_URL}/${uuid}`, data);
    return response.data;
  },

  deleteExpense: async (uuid: string) => {
    const response = await axiosWithAuth.delete(`${API_BASE_URL}/${uuid}`);
    return response.data;
  },

  restoreExpense: async (uuid: string) => {
    const response = await axiosWithAuth.post(`${API_BASE_URL}/${uuid}/restore`);
    return response.data;
  },

  getExpenseSummary: async (params: { startDate?: string; endDate?: string; storeId?: string } = {}) => {
    const response = await axiosWithAuth.get(`${API_BASE_URL}/summary`, { params });
    return response.data;
  },
};
